import type {PageContent} from "./content";

export const appendix: PageContent[] = [
  {
    type: 'empty'
  },
  {
    type: 'titular',
    text: {
      ru: "Приложение",
      en: "Appendix",
      uz: "Qo'shimcha"
    },
    subtitle: {
      ru: "Семья Бабура",
      en: "Babur's Family",
      uz: "Boburning oilasi"
    },
    title: {
      ru: "Приложение",
      en: "Appendix",
      uz: "Qo'shimcha"
    }
  },
  {
    type: 'regular',
    text: {
      ru: "**Кутлуг-Нигар-ханым** - старшая жена Умаршайха Мирзы II и **мать Захириддина Мухаммада Бабура**.\n\nЯвлялась второй дочерью великого хана Могулистана Юнус Хана и его главной супруги Айсан Долат Бегум. Носила титул **принцессы Могулистана**.",
      en: "**Qutlugh Nigar Khanum** - was the first wife and chief consort of Umar Shaikh Mirza II, and Babur’s mother.\n\nQutlugh Nigar Khanum was born as a princess of Moghulistan and was the second daughter of Yunus Khan, the Great Khan of Moghulistan, and his chief consort Aisan Daulat Begum.",
      uz: "**Qutlugʻ Nigorxonim** -  Umarshayx mirzo II ning toʻngʻich rafiqasi va **Zahiriddin Muhammad Boburning onasi**.\n\nQutlugʻ Nigorxonimning otasi Yunusxon Chingizxonning 2-oʻgʻli Chigʻatoyxon naslidan boʻlgan, onasi Eson Davlatbegim tuman beklaridan Sher Xonibekning qizi edi. **Mo'g'uliston malikasi unvoniga ega bo'lgan**."
    },
    img: 31
  },
  {
    type: 'regular',
    text: {
      ru: "Ханзада-бегим – дочь Омар Шейха Мирзы и госпожи Кутлуг Нигар Ханум, являлась сестрой Захириддина Мухаммада Бабура Мирзы и была супругой Мухаммада Шейбанихана. \n\nРодилась в Андижане в 1478 году.\nСогласно историческим данным, Ханзада-бегим была обладательницей хорошего вкуса, острого ума и смекалки.\n\nОна служила советником при дворе Бабуршаха и его сына Хумаюна — наследника престола.\n\nНа иллюстрации Ханзада-бегим изображена **в возрасте 13 лет**.",
      en: "Khanzada Begum, the daughter of Umar Shaikh Mirza and Kutlug Nigar Khanum, was the sister of Zahiriddin Muhammad Babur Mirza and was the wife of Muhammad Sheibanikhan.\n\nShe was born in Andijan in 1478.\nAccording to historical data, Khanzada Begum was the owner of good taste, sharp mind and ingenuity.\n\nShe served as an adviser to the court of Babur and his son Humayun, heir to the throne.\n\nIn the illustration, Khanzada Begum is depicted **at the age of 13**.",
      uz: "Xonzoda begim Umar Shayx Mirzo va Qutlug‘ Nigor xonimning qizi, Zahiriddin Muhammad Bobur Mirzoning opasi, Muhammad Shayboniyxonning ayoli bo‘lgan.\n\nU 1478-yilda Andijonda tug‘ilgan.\nTarixiy manbalarning shohidlik berishicha, Xonzoda begim did-farosatli, o‘tkir zehnli va aql-zakovat sohibasi bo‘lgan.\n\nXonzoda begim Boburshoh va uning taxt vorisi Humoyun shoh saroyida maslahatchi vazifasini bajargan.\n\nIllyustratsiyada Xonzoda begimning 13 yoshligi tasvirlangan."
    }
  },
  {
    type: 'regular',
    text: {
      ru: "**Джахангир-мирза** – Второй сын Омар Шейха Мирзы от  Фатимы-Султан, дочери могольского туманбека. **Сводный младший брат Бабура-Мирзы**.\n\nДжахангир-мирза был в центре внимания соперничающего кружка могольских эмиров за то, что они претендовали на родовые земли Омар Шейха Мирзы, Ферганскую долину, в первые годы правления Бабура в качестве молодого тимуридского принца.",
      en: "**Jahangir Mirza** — is the second son of Umar Shaikh Mirza, from Fatima Sultan, the daughter of the Mughal tumanbek. **Babur-Mirza's half-younger brother**.\n\nJahangir Mirza was the focus of a rival circle of Mughal emirs for claiming the ancestral lands of Umar Sheikh Mirza, the Fergana Valley, in the early years of Babur's reign as a young Timurid prince.",
      uz: "**Jahongir Mirzo** — Umar Shayx Mirzoning ikkinchi oʻgʻli, Moʻgʻul tuman bekining qizi Fotima Sultonning farzandi. **Bobur Mirzoning o‘gay ukasi**.\n\nJahongir Mirzo yosh temuriy shahzoda sifatida Bobur hukmronligining dastlabki yillarida Umar Shayx Mirzoning ajdodlari bo‘lmish Farg‘ona vodiysiga da’vogarlik qilgani uchun Mo‘g‘ul amirlarining raqib doirasi diqqat markazida bo‘lgan."
    },
    img: 33,
    imgSize: "narrow"
  },
  {
    type: 'regular',
    text: {
      ru: "Сарай-мульк ханым была дочерью чингизида – Казан-хана и супругой Амира Темура. \n\nСарай-мульк считалась старшей в гареме и носила титул «Бибиханум», что означает «старшая госпожа». \n\nТакже только ей позволялось сопровождать Амира Темура  в походах.",
      en: "Saray Mulk Khanum – was the daughter of Genghisid Qazan Khan and the chief consort of Amir Temur.\n\nSaray Mulk Khanum held the title \"Bibi Khanum\", which means \"senior mistress\".\n\nAlso, only she was allowed to accompany Amir Temur on campaigns.",
      uz: "Saroy Mulk xonim – chig‘atoy ulusiga mansub mo‘g‘ul xonlaridan Qozonxonning qizi,  Amir Temurning zavjasi bo’lgan. \n\nSaroy Mulk xonim haramdagi barcha malikalardan ulug‘rog‘i hisoblanib, «katta xonim» yoxud «Bibixonim» degan unvonga noil bo‘ladi. \n\nShuningdek, yurishlarda faqat unga Amir Temurni hamrohlik qilishga ruxsat berilgan."
    },
    img: 34
  },
  {
    type: 'regular',
    img: 35
  },
  {
    type: 'regular',
    text: {
      ru: `Мухаммад Шайбани-хан — внук правителя Узбекского ханства Абулхаир-хана и сын султана Шахбудога.

При рождении ему дали два имени — Мухаммад (арабское) и Шайбани-хан (турецкое) по обычаю тюрков.

В произведении «Бобурнома» он назван «шайбак-ханом», то есть «владельцем власти».

Шайбани — историческая личность, он **прошёл путь от главы наёмной армии до правителя, став ханом**.

Шайбани-хан с большим уважением относился к духовенству. Даже Бабур признаёт, что Шайбани-хан хорошо знал ислам. Вероятно, поэтому **Шайбани-хан считал себя покровителем и защитником мусульман**.

Учёные, жившие в период Шайбанидов, особенно поэты и историки, восхваляли его как **«Халифа ур-Рахмана»** и **«Имама аз-Замона»**, то есть  «божьего халифа на земле» и «имама эпохи».`,
      en: `**Muhammad Shaybani Khan** is the grandson of the ruler Uzbek ulus Abu'l-Khayr Khan and the son of Sultan Budaq.

At birth, he was given two names - Muhammad (Arabic) and Shaybanikhan (Turkish) according to the custom of the Turks.

In the work of "Boburnoma" he is called **"Shayabakhan"**, that is, "the owner of power."
Shaybani is a historical figure who has gone from the head of a mercenary army to the rank of ruler.

**Shaybani** Khan had great respect for the clergy. Even Babur admits that **Shaybani** knew Islam well. This is probably why **Shaybani** Khan considered himself the **patron and protector of Muslims**.

Scholars who lived during the Shaybanid period, especially poets and historians, praised him as **"Caliph ur-Rahman"** and **"Imam az-Zamon"**, that is, "Imam of the era" and "God's caliph on earth."`,
      uz: `Muhammad Shayboniyxon – Oʻzbek xonligi hukmdori Abulxayrxonning nabirasi, Shohbudogʻ sultonning oʻgʻli. 

Tug‘ilganda unga turkiylar odatiga ko‘ra ikki ism - Muhammad(arabcha) va Shayboniyxon (turkiycha) ismlari qo‘yilgan.

«Boburnoma» asarida esa u «Shayboqxon», ya\`ni «kuch-qudrat egasi» deb ataladi.
Shayboniy yollanma qo‘shin boshlig‘idan xon darajasiga ko‘tarilgan tarixiy shaxsdir. 

Shayboniyxon ruhoniy ulamolariga katta hurmat bilan munosabatda bo’lgan. Shayboniyxoning islom dini borasida yaxshi bilimga ega ekanligini hatto Bobur ham tan oladi. 

Shuning uchun bo‘lsa kerak Shayboniyxon **o‘zini musulmonlar, boshlig‘i va ularning ximoyachisi deb hisoblardi**. 

Shayboniylar davrida yashagan olimlar xususan, shoir va tarixchilar uni **"Xalifa ur-Rahmon"** va **"Imom az-Zamon"** ya\`ni "davr imomi" va "tangrining yerdagi xalifasi" deb ulug‘laganlar.`
    }
  },
  {
    type: 'regular',
    img: 36,
    text: {
      ru: "Бабур, [получивший весть о](#page-29) смерти отца Омара-Шейха Мирзы, мчится из Андижана в крепость [Ахсы](#page-28), преисполненный горем и воспоминаниями…",
      en: "Babur, upon [receiving news](#page-29) of his father Umar Shaikh Mirzа's death, rushed from Andijan to the fortress of [Akhsi](#page-28), filled with sorrow and memories.",
      uz: "Bobur otasi Umarshayx mirzoning [vafoti haqidagi xabarni](#page-29) eshitib, Andijondan [Axsi](#page-28) qo’rg’oniga qayg'u va xotiralarga to'lib otlanadi."
    }
  },
  {
    type: 'regular',
    img: 37,
    text: {
      ru: "Похороны Омара-Шейха Мирзы, крепость Ахсы: подданные охвачены горем, женщины гарема оплакивают своего повелителя.",
      en: "The funeral of Umar Shaikh Mirzа at the Ahsa fortress: the subjects are gripped with grief, and the women of the harem are mourning their ruler.",
      uz: "Axsa qal’asida Umar-Shayx Mirzoning dafn marosimi: xalq qayg‘uga botgan, haram ayollari o‘z hukmdoriga motam tutmoqda."
    }
  },
  {
    type: 'regular',
    img: 38
  },
  {
    type: 'regular',
    img: 39
  },
  {
    type: 'regular',
    img: 40,
    text: {
      ru: "Вступление Бабура на престол в возрасте 12 лет.",
      en: "Babur's accession to the throne at the age of 12.",
      uz: "Boburning 12 yoshida taxtga o‘tirishi."
    }
  },
  {
    type: 'regular',
    img: 48,
    imgSize: 'narrow',
    text: {
      ru: `Бабур — тимуридский царевич, создавший империю Бабуридов в Индии — был не только крупным государственным деятелем и полководцем, но и писателем и поэтом, занимавшим видное место в культуре и литературе средневекового Востока.

> Эти губы-сластены сыплют сахар слов на пиру,
> 
> Эти косы-арканы манят, расплетясь на ветру.
> 
> То лукавые брови сдвинешь, то прищуришь глаза,
> 
> Сколько бед я узнал, поверив в эту злую игру!`,
      en: `In India, the Timurid prince Babur established the Mughal Empire. Babur was not only a great ruler and leader but also an important writer and poet who played a significant role in the culture, literature, and poetry of the medieval East.`,
      uz: `Hindistonda Boburiylar saltanatini barpo etgan temuriy shahzoda Bobur, nafaqat yirik davlat arbobi va sarkarda, balki oʻrta asr Sharq madaniyati, adabiyoti hamda sheʼriyatida muhim oʻrin tutgan yozuvchi va shoir boʻlgan.

> Tishing dur, labing marjon, xading gul, xating rayxon,
> 
> Yuzung xur, soching anbar, suzung mul, menging meynon.
> 
> Meynon menging, suzing mul, anbar soching, yuzung xur,
> 
> Rayxon xating, xading gul, marjon labing, tishing dur.
> 
> Tafoxur kuzum, kunglum kilurlar magar bordur.`
    }
  }
];